import { feature, useFeature } from '@/app/context';
import type { SnapshotFrom } from 'xstate';
import { taxrulesetMachine } from './taxruleset.machine';

export const useTaxrulesetRef = () => feature('taxruleset');
export const useTaxruleset = <R>(selector: (snapshot: SnapshotFrom<typeof taxrulesetMachine>) => R) =>
  useFeature('taxruleset', selector);
